import { render, staticRenderFns } from "./DatasetItem.vue?vue&type=template&id=16b91d21&scoped=true&"
import script from "./DatasetItem.vue?vue&type=script&lang=js&"
export * from "./DatasetItem.vue?vue&type=script&lang=js&"
import style0 from "./DatasetItem.vue?vue&type=style&index=0&id=16b91d21&prod&lang=less&scoped=true&"
import style1 from "./DatasetItem.vue?vue&type=style&index=1&id=16b91d21&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b91d21",
  null
  
)

export default component.exports